/**
 * Constants for question categories and types.
 *
 * This file contains constant values used to identify different types of checklist questions
 * based on their category codes or other identifying attributes.
 */
export const ChecklistConstants = {
  InputType: {
    /** Code indicating a Date type question. */
    Date: "DTE",
    /** Code indicating a Short Text type question. */
    ShortText: "TSH",
    /** Code indicating a Long Text type question. */
    LongText: "LTG",
  },
} as const;
